<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import {
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogPortal,
    useForwardPropsEmits,
} from 'reka-ui'
import { cn } from '@/utils/shadcn'

const props = defineProps<{
    forceMount?: boolean
    disableOutsidePointerEvents?: boolean
    asChild?: boolean
    as?: unknown
    class?: unknown
}>()

const emits = defineEmits(['escapeKeyDown', 'openAutoFocus', 'closeAutoFocus'])

const delegatedProps = reactiveOmit(props, 'class')
const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
    <AlertDialogPortal>
        <AlertDialogOverlay
            class="fixed inset-0 z-[200] bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        />
        <AlertDialogContent
            v-bind="forwarded"
            :class="cn(
                'fixed left-1/2 top-1/2 z-[201] w-full max-w-sm -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl bg-white shadow-2xl duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
                props.class,
            )"
        >
            <slot />
        </AlertDialogContent>
    </AlertDialogPortal>
</template>
